import { Breakpoints } from '@material-ui/core/styles/createBreakpoints'

export const getFlexBreakpoint = (breakpointUp: Breakpoints['up']) =>
  breakpointUp('lg')
